import { ChildrenProp } from '../types_and_interfaces.ts'
import { cn } from '@/common/utilities.ts'

type LinkCardProps = {
  className?: string
  onClick: () => void
} & ChildrenProp

export default function LinkCard({
  children,
  className,
  onClick = () => {},
}: LinkCardProps) {
  return (
    <div
      className={cn(
        'cursor-pointer rounded-lg bg-white px-6 py-5 shadow-sm',
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

const Content = ({ children }: ChildrenProp) => {
  return <div>{children}</div>
}

LinkCard.Content = Content
